var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-padding no-margin"},[(_vm.path == '/member/prior-auths')?_c('PriorAuths'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }